<template>
  <div>
    <div class="handle">
      <el-button @click="batchDelete" :disabled="checkArray.length === 0"
        >批量移除</el-button
      ><el-button
        type="primary"
        @click="importExcel"
        v-if="form.messageForm.mqUserType === 1"
        >导入名单</el-button
      ><el-button
        type="primary"
        @click="managePersons"
        v-if="form.messageForm.mqUserType === 0"
        :disabled="form.messageForm.mqInfoType == 5 && !form.messageForm.bizId"
        >名单管理</el-button
      ><el-button type="primary" @click="showAddPersonModal" v-else>添加</el-button>
    </div>
    <div :key="'table' + form.messageForm.mqInfoType">
      <Table @selection-change="selectChange" :data="currentPersons" />
    </div>
    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-sizes="[10, 50, 100, 500, 1000]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="persons.length"
      background
      hide-on-single-page
    />
    <person-manage
      @addSucceed="didAddUser"
      :defaultCheckedKeys="persons"
      :showPersonManage="showPersonManage"
      :mqInfoType="form.messageForm.mqInfoType"
      :reportId="form.messageForm.bizId"
      v-if="showPersonManage.flag"
      @closeManage="closeManage"
    />
    <add-person v-if="showAddPerson.flag" :showAddPerson="showAddPerson" @addPersonHandle="addPersonHandle" @closeAddPerson="closeAddPerson"/>
    <no-sysUser-import :showImportModal="showImportModal" v-if="showImportModal.flag" @addSucceed="importSucceed" @closeDialog="closeImportModal"/>
    <!--中组部选调班选择学员-->
    <CenterSCPersonManage
      @addSucceed="didAddUser"
      :showCenterPersonManage="showCenterPersonManage"
      :mqInfoType="form.messageForm.mqInfoType"
      :classId="form.messageForm.classId"
      v-if="showCenterPersonManage.flag"
      @closeCenterManage="closeCenterManage"
    />
  </div>
</template>

<script>
import Table from "./table.js";
import vue from "@/main.js";
import PersonManage from "./personManage";
import AddPerson from "./addPerson";
import NoSysUserImport from "./noSysUserImport";
import { Confirm } from "@/components/Confirm";
import CenterSCPersonManage from "./centerSCPersonManage.vue";
export default {
  inject: ["form"],
  components: {
    Table,
    PersonManage,
    AddPerson,
    NoSysUserImport,
    CenterSCPersonManage
  },
  data() {
    return {
      checkArray: [],
      persons: [],
      currentPage: 1,
      currentSize: 10,
      showPersonManage: { flag: false },
      currentPersons: [],
      showAddPerson: { flag: false },
      showCenterPersonManage: { flag: false },
      showImportModal: { flag: false }
    };
  },
  methods: {
    closeManage() {
      this.showPersonManage = { flag: false };
    },
    closeCenterManage() {
      this.showCenterPersonManage = { flag: false };
    },
    closeAddPerson() {
      this.showAddPerson = { flag: false };
    },
    closeImportModal() {
      this.showImportModal = { flag: false };
    },
    // 导入
    importExcel() {
      this.showImportModal = { flag: true };
    },
    // 导入人员名单
    importSucceed(data) {
      let persons = data.map((ele) => {
        return {
          userName: ele.toUserName,
          userMobile: ele.toUserMobile,
        };
      });
      this.persons = persons.concat(this.persons);
      let obj = {};
      this.persons = this.persons.reduce((cur,next) => {
        obj[next.userMobile] ? "" : obj[next.userMobile] = true && cur.push(next);
        return cur;
      },[]) 
      this.getCurrentPersons();
    },
    // 系统用户：显示名单管理
    managePersons() {
      if (this.form.messageForm.mqInfoType == 6) {
        if (!this.form.messageForm.classId) {
          this.$message.error("请选择关联班级！");
        } else {
          // 中组部选调班-选择学员弹窗
          this.showCenterPersonManage = { flag: true };
        }
      } else {
        this.showPersonManage = { flag: true };
      }
    },
    // 非系统用户：显示添加学员弹窗
    showAddPersonModal() {
      this.showAddPerson = { flag: true };
    },
    selectChange(selections) {
      this.checkArray = selections;
    },
    // 非系统用户：添加名单
    addPersonHandle(persons) {
      this.showAddPerson = { flag: false };
      this.form.messageForm.mqUserType === 0
        ? (this.persons = persons)
        : this.persons.splice(0, 0, persons);
      this.getCurrentPersons();
    },
     // 系统用户：名单管理
    didAddUser(persons) {
      if (this.form.messageForm.mqInfoType == 6) {
        // 中组部选调班-选择学员弹窗
        this.showCenterPersonManage = { flag: false };
      } else {
        this.showPersonManage = { flag: false };
      }
      this.form.messageForm.mqUserType === 0
        ? (this.persons = persons)
        : this.persons.splice(0, 0, persons);
      this.getCurrentPersons();
    },
    getCurrentPersons() {
      this.currentPersons =  this.persons.slice(
        this.currentSize * (this.currentPage - 1),
        this.currentSize * this.currentPage
      );
    },
    handleSizeChange(size) {
      this.currentSize = size;
      this.getCurrentPersons();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getCurrentPersons();
    },
    // 批量删除人员
    async batchDelete() {
      const text = "确定删除该人员吗?";
      try {
        await Confirm(text, "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        // 批量删除
        let arrayDifference = (a, b) => {
          // 差集 a - b
          let clone = a.slice(0); // clone = a
          for (let i = 0; i < b.length; i++) {
            let temp = b[i];
            for (var j = 0; j < clone.length; j++) {
              if (temp === clone[j]) {
                clone.splice(j, 1); // remove clone[j]
              }
            }
          }
          return clone;
        };
        let filterData = (array) => {
          // 去重
          return Array.from(new Set(array));
        };
        this.persons = filterData(
          arrayDifference(this.persons, this.checkArray)
        );
        this.getCurrentPersons();
      } catch (error) {
        if (error === "cancel") return;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  margin-top: 10px;
}
.handle {
  text-align: right;
  margin-bottom: 10px;
}
</style>
